module.exports = __webpack_public_path__ + "static/media/smile-wink.7911937c.svg";